export default "__VITE_ASSET__6fbd8e44__"